import './App.css';
import PostProcess from "./UI/postProcess";

function App() {
  return (
    <PostProcess/>
  );
}

export default App;
